module.exports = __webpack_public_path__ + "img/ic_dashboard_medal_bronze.6844c341.svg";